<template>
  <div class="row formJov">
    <div class="col-lg-12">
      <span class="ml-3 f14 font-weight-bold">TÍTULO DA PROVA</span>
      <inputform
        v-model="evaluation_edit.name"
        type="text"
        :field="$v.evaluation_edit.name"
        class="label-bold mt-2"
      />
    </div>
    <div class="col-lg-12">
      <span class="ml-3 f14 font-weight-bold">DESCRIÇÃO</span>
      <ckeditor
        v-model="evaluation_edit.description"
        class="mt-2"
        :class="{
          'is-invalid': $v.evaluation_edit.description.$error,
          'is-valid': !$v.evaluation_edit.description.$invalid,
        }"
      />
    </div>
    <div class="col-lg-12 mt-3 note-container">
      <div class="d-flex mb-3">
        <SwitchCheckbox
          v-model="evaluation_edit.next_level_by_grade"
          label="LEVAR PARA PRÓXIMA FASE BASEADO NA NOTA?"
        />
      </div>
      <div v-if="evaluation_edit.next_level_by_grade">
        <span class="ml-3 f14 font-weight-bold">NOTA MÍNIMA (0 à 100)</span>
        <input
          class="form-control"
          type="number"
          v-model.number="evaluation_edit.minimum_passing_grade"
        />
        <span class="mt-3 f14 font-weight-bold">MOVER PARA</span>

        <select
          v-model="evaluation_edit.next_phase_id"
          class="form-control col-xl-12 mt-1"
          style="text-transform: uppercase"
        >
          <option
            class="form-control"
            v-for="selective_process in selective_processes"
            :key="selective_process.id"
            :value="selective_process.id"
          >
            {{ selective_process.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="col-lg-12 mt-3 note-container">
      <div class="d-flex mb-3">
        <SwitchCheckbox
          v-model="evaluation_edit.auto_disapprove"
          label="REPROVAR BASEADO NA NOTA?"
        />
      </div>
    </div>

    <div class="col-lg-12 mt-3 note-container">
      <div class="d-flex mb-3">
        <SwitchCheckbox
          v-model="evaluation_edit.time_per_question"
          label="TEMPO POR PERGUNTA?"
        />
      </div>
    </div>

    <div class="col-lg-12 mt-3 note-container">
      <div class="d-flex mb-3">
        <SwitchCheckbox
          v-model="evaluation_edit.general_time"
          label="TEMPO LIMITE DA PROVA"
        />
      </div>
      <div v-if="evaluation_edit.general_time">
        <span class="ml-3 f14 font-weight-bold"
          >TEMPO TOTAL DA PROVA (em minutos)</span
        >
        <input
          class="form-control"
          type="number"
          v-model.number="evaluation_edit.time_total_to_response"
        />
      </div>
    </div>

    <div class="col-lg-12 mt-3">
      <span class="ml-3 f14 font-weight-bold">
        EM QUAL ETAPA ESTÁ PERGUNTA IRÁ:
      </span>
      <select
        v-model="evaluation_edit.selective_process_id"
        class="form-control col-xl-12"
        style="text-transform: uppercase"
      >
        <option
          class="form-control"
          v-for="selective_process in selective_processes"
          :key="selective_process.id"
          :value="selective_process.id"
        >
          {{ selective_process.name }}
        </option>
      </select>
    </div>

    <div class="col-lg-12 mt-3">
      <span class="ml-3 f14 font-weight-bold"> ORDEM DA PROVA </span>
      <input
        type="number"
        class="form-control"
        v-model.number="evaluation_edit.ordernation"
      />
    </div>

    <div class="col-lg-12 mt-3">
      <button @click="save" class="btn btn-primary full radius-0 f13 h-100">
        Salvar
      </button>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import SwitchCheckbox from "../Jobs/SwitchCheckbox.vue";

export default {
  props: {
    job_id: {
      type: Number,
      required: true,
    },
    evaluation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      evaluation_edit: {
        id: null,
        name: "",
        description: "",
        minimum_passing_grade: 0,
        next_level_by_grade: false,
        time_per_question: false,
        time_total_to_response: 0,
        next_phase_id: null,
        general_time: false,
        auto_disapprove: false,
        ordernation: 0,
      },
      selective_processes: [],
      default_process_id: null,
    };
  },
  components: {
    SwitchCheckbox,
  },
  mounted() {
    this.evaluation_edit.name = this.evaluation.name;
    this.evaluation_edit.id = this.evaluation.id;
    this.evaluation_edit.description = this.evaluation.description;
    this.evaluation_edit.time_per_question = this.evaluation.time_per_question;
    this.evaluation_edit.minimum_passing_grade =
      this.evaluation.minimum_passing_grade;

    this.evaluation_edit.next_level_by_grade =
      this.evaluation.next_level_by_grade;

    this.evaluation_edit.time_total_to_response =
      this.evaluation.time_total_to_response;

    this.evaluation_edit.next_phase_id = this.evaluation.next_phase_id;
    this.evaluation_edit.general_time = this.evaluation.general_time;

    this.evaluation_edit.auto_disapprove = this.evaluation.auto_disapprove;
    this.evaluation_edit.ordernation = this.evaluation.ordernation;

    this.$root.$on("columnsChanged", (selective_processes) => {
      this.selective_processes = selective_processes;
      this.default_process_id = selective_processes.filter(
        (process) => process.status === 1
      )[0].id;
      this.evaluation_edit.selective_process_id = this.evaluation
        .selective_process_id
        ? this.evaluation.selective_process_id
        : this.default_process_id;
    });
  },
  watch: {
    "evaluation_edit.time_per_question": function (newVal) {
      if (newVal === true) {
        this.evaluation_edit.general_time = false;
      }
    },
    "evaluation_edit.general_time": function (newVal) {
      if (newVal === true) {
        this.evaluation_edit.time_per_question = false;
      }
    },
  },
  methods: {
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      if (this.evaluation_edit.next_level_by_grade) {
        if (!this.configToNextPhaseByNote) {
          this.$toast.error("É necessário informar a nota mínima");
          return;
        }
        if (this.evaluation_edit.minimum_passing_grade > 100) {
          this.$toast.error("A nota limite é 100");
          return;
        }
      }

      if (this.evaluation_edit.general_time) {
        if (!this.configSetupTimeToEvaluation) {
          this.$toast.error("É necessário informar o tempo limite da prova");
          return;
        }
      } else {
        this.evaluation_edit.time_total_to_response = 0;
      }

      if (this.evaluation_edit.id) {
        axios
          .put("/recruiters/evaluations/" + this.evaluation_edit.id, {
            evaluation: {
              name: this.evaluation_edit.name,
              description: this.evaluation_edit.description,
              job_id: this.job_id,
              selective_process_id: this.evaluation_edit.selective_process_id,
              minimum_passing_grade: this.evaluation_edit.minimum_passing_grade,
              next_level_by_grade: this.evaluation_edit.next_level_by_grade,
              time_per_question: this.evaluation_edit.time_per_question,
              time_total_to_response:
                this.evaluation_edit.time_total_to_response,
              next_phase_id: this.evaluation_edit.next_phase_id,
              general_time: this.evaluation_edit.general_time,
              auto_disapprove: this.evaluation_edit.auto_disapprove,
              ordernation: this.evaluation_edit.ordernation,
            },
          })
          .then(() => {
            this.$toast.success("Prova atualizada com sucesso!");
          });
      } else {
        axios
          .post("/recruiters/evaluations", {
            evaluation: {
              name: this.evaluation_edit.name,
              description: this.evaluation_edit.description,
              job_id: this.job_id,
              selective_process_id: this.evaluation_edit.selective_process_id,
              minimum_passing_grade: this.evaluation_edit.minimum_passing_grade,
              next_level_by_grade: this.evaluation_edit.next_level_by_grade,
              time_per_question: this.evaluation_edit.time_per_question,
              time_total_to_response:
                this.evaluation_edit.time_total_to_response,
              next_phase_id: this.evaluation_edit.next_phase_id,
              general_time: this.evaluation_edit.general_time,
              auto_disapprove: this.evaluation_edit.auto_disapprove,
              ordernation: this.evaluation_edit.ordernation,
            },
          })
          .then(() => {
            this.$toast.success("Prova criada com sucesso!");
          });
      }
    },
  },
  computed: {
    configSetupTimeToEvaluation() {
      return (
        this.evaluation_edit.time_total_to_response != "" &&
        this.evaluation_edit.time_total_to_response != 0
      );
    },
    configToNextPhaseByNote() {
      return (
        this.evaluation_edit.minimum_passing_grade !== "" &&
        this.evaluation_edit.minimum_passing_grade > 0
      );
    },
  },
  validations: {
    evaluation_edit: {
      name: {
        required,
      },
      description: {
        required,
      },
    },
  },
};
</script>

<style scoped>
.note-container {
  display: flex;
  justify-items: start;
  flex-direction: column;
}
</style>
